import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ViewTradingServices from '../../../services/ViewTradingServices';

function WebhookUpdate({ web, closeModal }) {
  // console.log(notification)
  const [formValues, setFormValues] = useState({
    scannerType: '',
    url: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 

  useEffect(() => {
    if (web) {
      setFormValues({
        scannerType: web?.scannerType || '',
        url: web?.url || '',
      });
    }
  }, [web]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleDescriptionChange = (value) => {
    setFormValues({
      ...formValues,
      description: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        file: file,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('scannerType', formValues.scannerType);
    formData.append('url', formValues.url);
    try {
      await ViewTradingServices.updateWebhooks(web._id, formData);
      alert('Webhook updated successfully');
      closeModal();
    } catch (error) {
      console.error('Failed to update webhook', error);
      alert('Failed to update webhook');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Webhook Update</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input-field">
                          <label>Scanner Type</label>
                          <input
                            type="text"
                            name="scannerType"
                            value={formValues.scannerType}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="input-field">
                          <label>Url</label>
                          <input
                            type="text"
                            name="url"
                            value={formValues.url}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      
                    </div>
                    <button type="submit" className="submit-green-btn" >
                      SUBMIT
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebhookUpdate;
